import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";

import { FormToolsService } from "@atenea-cms";

@Component({
  selector: "product-software-slide-form",
  templateUrl: "./product-software-slide-form.component.html",
  styleUrls: ["./product-software-slide-form.component.scss"],
})
export class ProductSoftwareSlideFormComponent {
  @Input() form: FormGroup;

  constructor(public ft: FormToolsService) {}
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/product-software-slide-form/product-software-slide-form.component.ts